<script lang="ts">
  import { config } from '#app/config'
  import Link from '#app/lib/components/link.svelte'
  import Tooltip from '#components/tooltip.svelte'
  import { getWikidataUrl } from '#entities/lib/entities'
  import type { RelativeUrl } from '#server/types/common'
  import type { EntityUri } from '#server/types/entity'
  import { i18n } from '#user/lib/i18n'

  const { publicHost } = config

  const {
    uri,
  }: {
    uri: EntityUri
  } = $props()

  const internalUrl = $derived(`/entity/${uri}` as RelativeUrl)
  const wikidataUrl = $derived(getWikidataUrl(uri))
</script>

<Tooltip>
  {#snippet primary()}
    <div>
      <span class="uri">{uri}</span>
    </div>
  {/snippet}
  {#snippet tooltipContent()}
    <div class="tooltip-content">
      <Link
        url={internalUrl}
        text={i18n('see_on_website', { website: publicHost })}
        light={true}
      />
      {#if wikidataUrl}
        <Link
          url={wikidataUrl}
          text={i18n('see_on_website', { website: 'wikidata.org' })}
          light={true}
        />
      {/if}
    </div>
  {/snippet}
</Tooltip>

<style lang="scss">
  @import "general/scss/utils";

  .uri{
    font-size: 0.7rem;
    font-family: sans-serif;
    color: #888;
    overflow-wrap: anywhere;
  }

  /* Small screens */
  @media screen and (width < 700px){
    .tooltip-content{
      @include display-flex(column);
      :global(a){
        padding: 0.5em;
      }
    }
  }

  /* Larger screens */
  @media screen and (width >= 700px){
    .tooltip-content{
      :global(a){
        padding: 0.5em;
        &:not(:first-child){
          // Compensate for the presence of the hereafter defined separator
          padding-inline-start: 0;
          // Separator
          &::before{
            content: "|";
            padding-inline-end: 0.6em;
            // Prevent to be underlined when the .link is hovered
            text-decoration: none;
            // Hack to get text-decoration to apply: https://stackoverflow.com/a/15688237/3324977
            display: inline-block;
          }
        }
      }
    }
  }

</style>
